import { Inbox } from "lucide-react";

export function EmptyState({ icon: Icon = Inbox, title, description, actionLabel, onAction, testid }) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center" data-testid={testid || "empty-state"}>
      <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-2xl border border-white/[0.06] bg-[#0A0A0A]">
        <Icon className="h-7 w-7 text-[#FF1C2A]" strokeWidth={1.6} />
      </div>
      <h3 className="font-display text-lg font-semibold text-white">{title}</h3>
      {description && <p className="mt-2 max-w-sm text-sm text-neutral-500">{description}</p>}
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="mt-6 rounded-lg bg-[#E30613] px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#FF1C2A]"
          data-testid="empty-state-action"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
